import { Outlet } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Box from 'components/ui/box';
import { useEffect, useRef, useState } from 'react';
import { getResultadosCultura, getSeloRealizacao } from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import { TbSearch } from 'react-icons/tb';
import { BsPlusLg } from 'react-icons/bs';
import { RealizacaoDetail } from './detail';
import ReactPaginate from 'react-paginate';
import { getNamedDates } from 'services/utils';

const release = true;

interface DestaqueCulturaProps {
  showHead: (item: boolean) => void;
  options: any;
}

const collections = {
  coletiva: 'realizacoes_coletivas',
  selo: 'selo_realizacao',
  premiacao: 'realizacoes_premiadas',
};

export default function Realizacao({ options, showHead }: DestaqueCulturaProps) {
  const [list, setList] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [showDetail, setShowDetail] = useState<any>('');
  const [selectedValue, setSelectedValue] = useState<'coletiva' | 'selo' | 'premiacao'>('premiacao');
  const [isMounted, setIsMounted] = useState(false);

  const [mask] = useState('');

  const searchRef = useRef<any>();

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const getAriaLabel = (pageIndex: number, selected: boolean) => {
    return selected ? `Página ${pageIndex + 1} selecionada` : `Ir para a página ${pageIndex + 1}`;
  };

  useEffect(() => {
    const pageLinks = document.querySelectorAll('.page-link');
    pageLinks.forEach((link, index) => {
      link.setAttribute('aria-label', getAriaLabel(index, link.classList.contains('active')));
    });
  });

  async function loadData(e?: any, itemPage?: number, clear?: boolean) {
    if (!options) return;

    if ((options?.date_start < 1690772400000 || options?.date_start >= getNamedDates().ciclo_1S2025) && selectedValue !== 'selo') {
      setSelectedValue('selo');
      return;
    }

    setLoadingList(true);

    if (e) {
      e.preventDefault();
    }

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setList([]);

      const data = await getSeloRealizacao(searchRef.current.value, options._id, rangeItem, collections[selectedValue]);

      setPage(data.range.pages);
      setList(data.result);
      setLoadingList(false);
      setIsMounted(true);
    } catch (e) {}
  }

  useEffect(() => {
    if (options) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue, options]);

  useEffect(() => {
    showHead(!!showDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetail]);

  if (!!showDetail)
    return (
      <RealizacaoDetail
        onClose={() => setShowDetail('')}
        id={showDetail.matricula}
        data={showDetail}
        tab={selectedValue}
        active={options}
      />
    );

  return (
    <>
      <div className="overflow-hidden">
        {/* <div className=" mb-3 lg:mb-10">
          <div className="flex flex-row items-center space-x-3 lg:space-x-1">
            <h1 className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
              <span>Realizações Destaque</span>{' '}
              <Tippy arrow={true} className="" allowHTML={true} content={typeText()}>
                <div>
                  <AiOutlineInfoCircle />
                </div>
              </Tippy>
              <span>|</span> <span className="text-yellow">{options?.label}</span>
            </h1>
          </div>
        </div> */}

        <div className="mb-5 lg:flex items-center justify-end space-x-5">
          {/* <div className="w-full mb-3 lg:mb-0 lg:w-[264px]">
            <CustomSelect
              placeholder="Clique para selecionar o ciclo"
              options={options}
              value={options[getIndexByValue(options, activeItem)]}
              onChange={(e: any) => setActiveItem(e.value)}
            />
          </div> */}

          <div className="flex flex-row items-center space-x-4">
            <form onSubmit={e => loadData(e, 0, true)} className="pl-1 -ml-1 flex-1 flex space-x-5">
              <label htmlFor="search-realizacao-input" className="sr-only">
                Pesquise com nome, matrícula, prefixo ou grupo
              </label>
              <InputMask
                id="search-realizacao-input"
                placeholder="Pesquise com nome, matrícula, prefixo ou grupo"
                alwaysShowMask={false}
                mask={mask}
                ref={(ref: any) => {
                  searchRef.current = ref;
                }}
                inputMode="search"
                style={{ fontSize: 16 }}
                className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                aria-label="Campo de pesquisa"
              />
            </form>

            <button
              type="button"
              onClick={() => loadData(null, 0, true)}
              className="p-1 hover:ring-2 rounded-full"
              aria-label="Buscar"
            >
              <TbSearch size={28} aria-hidden="true" />
            </button>
          </div>
        </div>

        {options?.date_start >= 1690772400000  && !loadingList && (
          <div className="mb-5 space-y-2">
            <p className="mb-4" id="filter-realizacao-label">
              Filtre por categorias de realização
            </p>
            <div className="flex space-x-2 overflow-auto" role="group" aria-labelledby="filter-realizacao-label">
              {options?.date_start < getNamedDates().ciclo_1S2025 && <button
                className={`${
                  selectedValue === 'premiacao' ? 'bg-electric-blue text-prussian-blue-3' : 'border-2'
                } border-grey-light  rounded-3xl py-1 px-3 uppercase`}
                onClick={() => setSelectedValue('premiacao')}
                aria-pressed={selectedValue === 'premiacao'}
              >
                Premiação em Espécie
              </button>}
              <button
                className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                  selectedValue === 'selo'
                    ? 'bg-electric-blue text-maastricht-blue border-transparent'
                    : 'bg-transparent text-white border-white'
                }`}
                onClick={() => setSelectedValue('selo')}
                aria-pressed={selectedValue === 'selo'}
              >
                Selos
              </button>
              {options?.date_start < 1730084400000 && (
                <button
                  className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                    selectedValue === 'coletiva'
                      ? 'bg-electric-blue text-maastricht-blue border-transparent'
                      : 'bg-transparent text-white border-white'
                  }`}
                  onClick={() => setSelectedValue('coletiva')}
                  aria-pressed={selectedValue === 'coletiva'}
                >
                  Realizações coletivas
                </button>
              )}
            </div>
          </div>
        )}

        {!release ? (
          <Box>
            <div className="space-y-5 lg:p-3">
              <div className="text-center">
                <h3 className="text-xl">Em breve</h3>
              </div>
            </div>
          </Box>
        ) : null}
        {release ? (
          <div className="space-y-5 pt-5">
            {loadingList && (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            )}

            <div className={`${loadingList && 'hidden'} space-y-2`}>
              <div className="flex flex-col space-y-5">
                <Box>
                  {!loadingList && list?.length === 0 && (
                    <div className="text-center">
                      <h3 className="text-xl">Nenhum resultado encontrado</h3>
                    </div>
                  )}

                  <div className="space-y-2">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" role="list">
                      {list?.map((item: any, index) => (
                        <button
                          className="bg-maastricht-blue rounded-xl text-white space-y-2 hover:ring-2 h-fit text-left w-full"
                          key={item?._id + '-' + item.behavior + index}
                          onClick={() => handleDetail(item)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleDetail(item);
                            }
                          }}
                          aria-label={`Ver detalhes de ${item.nome}, ${item.diretoria} - ${item.funcao}, matrícula ${item.matricula}, grupo: ${item.grupo}`}
                          role="listitem"
                        >
                          <div className="px-4 relative">
                            <div className="flex flex-col items-center justify-around md:h-40 space-y-1 text-center">
                              <div className="w-28 h-28 overflow-hidden rounded-full bg-purple text-3xl font-bold flex flex-row items-center justify-center">
                                {!!item.avatar_type &&
                                  (item.image ? (
                                    <img src={item.image} alt={`Avatar de ${item.nome}`} className="w-full h-full" />
                                  ) : (
                                    <span aria-label={`Inicial ${item.nome[0]}`}>{item.nome[0]}</span>
                                  ))}
                                {!item.avatar_type &&
                                  (!!item.avatar ? <Avatar className="w-full h-full" {...item.avatar} /> : <span aria-label={`Inicial ${item.nome[0]}`}>{item.nome[0]}</span>)}
                              </div>

                              {/* <div className="w-20 absolute -top-3 -right-3">
                                {behaviors[item.behavior].icon}
                              </div> */}
                            </div>
                          </div>

                          <div className="bg-prussian-blue-3 w-full  text-center pb-7 pt-5 rounded-b-xl h-[55%]">
                            <div className="font-bold">
                              {item.nome_guerra} - {<span className="font-thin text-electric-blue">{item.matricula}</span>}
                            </div>
                            <span className="font-thin">{item.nome} </span>
                            <div className="mt-0">
                              <span className="text-electric-blue font-thin">{item.diretoria} </span>
                              <span className="font-thin">- {item.funcao}</span>
                            </div>
                            <div className="text-electric-blue mb-3">
                              <span>Grupo: {item.grupo}</span>
                            </div>

                            <div className="mt-4">
                              <BsPlusLg className="mr-2 inline-block" size={17} color="#C2D2FF" aria-hidden="true" />
                              <span className="uppercase">Ver mais</span>
                            </div>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                </Box>

                <nav className={`flex justify-center mt-5 ${page < 2 && 'hidden'}`} aria-label="Navegação de páginas">
                  <ReactPaginate
                    pageLinkClassName={'page-link'}
                    activeClassName={'item active '}
                    breakClassName={'item break-me '}
                    breakLabel={'...'}
                    containerClassName={'pagination'}
                    disabledClassName={'disabled-page'}
                    nextClassName={'item next '}
                    pageClassName={'item pagination-page '}
                    previousClassName={'item previous'}
                    initialPage={0}
                    forcePage={activePag}
                    nextLabel={<><IoIosArrowForward style={{ fontSize: 18, width: 150 }} aria-hidden="true" /><span className="sr-only">Próxima página</span></>}
                    onPageChange={data => loadData(null, data.selected)}
                    pageRangeDisplayed={3}
                    pageCount={page}
                    previousLabel={<><IoIosArrowBack style={{ fontSize: 18, width: 150 }} aria-hidden="true" /><span className="sr-only">Página anterior</span></>}
                    ariaLabelBuilder={(pageIndex) => `Ir para a página ${pageIndex}`}
                  />
                </nav>
                {/* </div> */}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Outlet />
    </>
  );
}
